import styled from 'styled-components';

export const Content = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0c1210;
  border: 1.5px solid #3d4952;
  box-sizing: border-box;
  margin-right: 20px;
  border-radius: 50%;
  cursor: pointer;
  transition: border-color 0.15s ease;
  &:hover {
    border-color: #47b972;
  }
  &.sm {
    width: 22px;
    height: 22px;
  }
`;

export const IndicatorActive = styled.div`
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-color: #47b972;
  &.sm {
    width: 12px;
    height: 12px;
  }
`;
